import { IconArrowUpRight } from '@tabler/icons-react';

const SandboxNoticeBar = () => {
  if (process.env.REACT_APP_SANDBOX_MODE !== 'true') return null;

  const productionUrl = process.env.REACT_APP_PRODUCTION_URL;

  return (
    <div className="sticky top-0 z-[60] w-full">
      <div className="h-1 w-full bg-error-main" />
      <div className="flex justify-center">
        <div className="flex items-center gap-2 rounded-b-lg rounded-t-none bg-error-main px-4 py-1 text-sm font-bold text-error-contrastText shadow-sm">
          <span>
            You&apos;re in Sandbox Mode, No real transactions will be processed
          </span>
          {productionUrl ? (
            <a
              href={productionUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1 underline transition-opacity hover:opacity-80"
            >
              Move to Production
              <IconArrowUpRight className="h-3.5 w-3.5" />
            </a>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default SandboxNoticeBar;
